// extracted by mini-css-extract-plugin
export var billingAddress = "_xe-g";
export var contactInfo = "_xe-d";
export var customerInfoContainer = "_xe-c";
export var customerInfoContainerMobile = "_xe-h";
export var customerInfoRow = "_xe-a";
export var customerInfoSection = "_xe-b";
export var fullWidthDividerMobile = "_xe-i";
export var imageContainer = "_xe-1";
export var paymentMethod = "_xe-e";
export var priceText = "_xe-6";
export var priceTextMobile = "_xe-7";
export var product = "_xe-0";
export var productImage = "_xe-2";
export var productInfo = "_xe-4";
export var productMobile = "_xe-9";
export var productTitle = "_xe-8";
export var quantityBadge = "_xe-3";
export var quantityText = "_xe-5";
export var shippingAddress = "_xe-f";